import { render, staticRenderFns } from "./payment-records.vue?vue&type=template&id=c9c3aa70&scoped=true&"
import script from "./payment-records.vue?vue&type=script&lang=js&"
export * from "./payment-records.vue?vue&type=script&lang=js&"
import style0 from "./payment-records.vue?vue&type=style&index=0&id=c9c3aa70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c3aa70",
  null
  
)

export default component.exports